import { USER_ROLES } from './constants';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const RolesPage = () => {
  return (
    <>
      <PageBar />

      <div className="mb-3">
        {USER_ROLES.map((item) => (
          <EntityCard
            key={item.id}
            title={item.name}
          />
        ))}
      </div>
    </>
  );
};

export default RolesPage;
